function BillGeneration() {
  return <div>BillGeneration</div>;
}

export default BillGeneration;
